/**
 * Created by portiz on 01/23/2019.
 */
import React from 'react';
import {Input, Col, Label, Alert, Row, Button} from 'reactstrap';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from '../../custom-classes/api-calls';
import SelectorCurrency from '../selectors/selector-currency';
import SelectorBillingInterval from '../selectors/selector-billing-interval';
import SelectorPlanProduct from '../selectors/selector-plan-product';
import CheckboxTaxes from '../selectors/multi-selector-taxes';
import CheckboxCountries from '../selectors/multi-selector-country';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import PlanDescriptionEditorSN from '../html-editor/plan-description-editor-sn';
import ModalPlanSelection from '../modals/modal-plan-selection';

/**
 * Class to handle the created plans
 */
class FormGroupPlans extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            languages: [],
            currencyIsoCode: props.data.currencyIsoCode ? props.data.currencyIsoCode : null,
            interval: props.data.interval ? props.data.interval : null,
            productId: props.data.productId ? props.data.productId : null,
            planName: props.data.planName ? props.data.planName : '',
            price: props.data.price ? props.data.price : null,
            validPrice: props.data.validPrice ? props.data.validPrice : false,
            tryPeriod: props.data.tryPeriod ? props.data.tryPeriod : null,
            isForSchoolChecked: props.data.isForSchoolChecked ? props.data.isForSchoolChecked : false,
            isPrivate: props.data.isPrivate ? props.data.isPrivate : false,
            studentQuantity: props.data.studentQuantity ? props.data.studentQuantity : '',
            validStudentQuantity: props.data.validStudentQuantity ? props.data.validStudentQuantity : false,
            isAvailableChecked: props.data.isAvailableChecked ? props.data.isAvailableChecked : false,
            taxesSelected: props.data.taxesSelected ? props.data.taxesSelected : [],
            planDescriptionDetails: props.data.planDescriptionDetails ? props.data.planDescriptionDetails : [], // Example: [{langCode: 'en', title: 'In english', description: 'In English desc'}]
            validDescriptions: props.data.validDescriptions ? props.data.validDescriptions : false,
            planAvailableIsos: props.data.planAvailableIsos ? props.data.planAvailableIsos : [],
            checkedValues: props.data.checkedValues ? props.data.checkedValues : [],
            checkedRegionsValues: props.data.checkedRegionsValues ? props.data.checkedRegionsValues : [],
            selectAll: props.data.selectAll ? props.data.selectAll : false,
            planSubmitEnabled: props.data.planSubmitEnabled ? props.data.planSubmitEnabled : false,
            loading: false,
            showModal: false,
            planId: props.data.planId ? props.data.planId : null,
            disabledGenerics: props.data.disabledGenerics,
            disabledPlanName: props.data.disabledPlanName,
            disabledPlanForSchools: props.data.disabledPlanForSchools,
            disabledPrivatePlan: props.data.disabledPrivatePlan,
            disabledProfilesQuantity: props.data.disabledProfilesQuantity,
            disabledPlanAvailability: props.data.disabledPlanAvailability,
            disabledPlanDescriptions: props.data.disabledPlanDescriptions,
            disabledRegionCountryIsos: props.data.disabledRegionCountryIsos,

            planDescriptionCurrentLangCode: null,
            planDescriptionCurrentTitle: null,
            planDescriptionCurrentDescription: null,
            planDescriptionCurrentLangName: null,
            planDescriptionShowModal: false,

            isEdit: props.data.isEdit ? props.data.isEdit : false,
            isReadOnly: props.data.isReadOnly ? props.data.isReadOnly : false,

            modalPlanVisible: false,

            showAddExistingPlanButton: true // To show or hide the button to open an existing plan
        }; // Default value


        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleInterval = this.handleInterval.bind(this);
        this.handleProduct = this.handleProduct.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePriceChange = this.handlePriceChange.bind(this);
        this.isNormalInteger = this.isNormalInteger.bind(this);
        this.handleTry = this.handleTry.bind(this);
        this.handleIsForSchool = this.handleIsForSchool.bind(this);
        this.handleIsPrivate = this.handleIsPrivate.bind(this);
        this.handleStudentQuantity = this.handleStudentQuantity.bind(this);
        this.handlePlanAvailability = this.handlePlanAvailability.bind(this);
        this.handleCheckedTaxes = this.handleCheckedTaxes.bind(this);
        this.handleChangeDescriptionEditor = this.handleChangeDescriptionEditor.bind(this);
        this.handleCountryRegionsSelected = this.handleCountryRegionsSelected.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.submitPlan = this.submitPlan.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.validateDescriptions = this.validateDescriptions.bind(this);
        this.renderDescriptions = this.renderDescriptions.bind(this);
        this.searchLanguages = this.searchLanguages.bind(this);
        this.openPlanDescriptionModal = this.openPlanDescriptionModal.bind(this);
        this.updateDescriptionText = this.updateDescriptionText.bind(this);
        this.searchDescriptionTextByLangCode = this.searchDescriptionTextByLangCode.bind(this);
        this.searchTitleTextByLangCode = this.searchTitleTextByLangCode.bind(this);
        this.handleOnClickSearchPlan = this.handleOnClickSearchPlan.bind(this);
        this.handleSelectedPlan = this.handleSelectedPlan.bind(this);
    }


    componentWillReceiveProps(props) {
        if (typeof props.data !== 'undefined' && this.props.data.isEdit) {
            this.setState({
                currencyIsoCode: props.data.currencyIsoCode ? props.data.currencyIsoCode : null,
                interval: props.data.interval ? props.data.interval : null,
                productId: props.data.productId ? props.data.productId : null,
                planName: props.data.planName ? props.data.planName : '',
                price: props.data.price ? props.data.price : null,
                validPrice: props.data.validPrice ? props.data.validPrice : false,
                tryPeriod: props.data.tryPeriod ? props.data.tryPeriod : null,
                isForSchoolChecked: props.data.isForSchoolChecked ? props.data.isForSchoolChecked : false,
                isPrivate: props.data.isPrivate ? props.data.isPrivate : false,
                studentQuantity: props.data.studentQuantity ? props.data.studentQuantity : '',
                validStudentQuantity: props.data.validStudentQuantity ? props.data.validStudentQuantity : false,
                isAvailableChecked: props.data.isAvailableChecked ? props.data.isAvailableChecked : false,
                taxesSelected: props.data.taxesSelected ? props.data.taxesSelected : [],
                planDescriptionDetails: props.data.planDescriptionDetails ? props.data.planDescriptionDetails : [], // Example: [{langCode: 'en', title: 'In english', description: 'In English desc'}]
                validDescriptions: props.data.validDescriptions ? props.data.validDescriptions : false,
                planAvailableIsos: props.data.planAvailableIsos ? props.data.planAvailableIsos : [],
                checkedValues: props.data.checkedValues ? props.data.checkedValues : [],
                checkedRegionsValues: props.data.checkedRegionsValues ? props.data.checkedRegionsValues : [],
                selectAll: props.data.selectAll ? props.data.selectAll : false,
                planSubmitEnabled: props.data.planSubmitEnabled ? props.data.planSubmitEnabled : false,
                loading: false,
                showModal: false,
                showAddExistingPlanButton: false,
                planId: props.data.planId ? props.data.planId : null,
                disabledGenerics: props.data.disabledGenerics,
                disabledPlanName: props.data.disabledPlanName,
                disabledPlanForSchools: props.data.disabledPlanForSchools,
                disabledPrivatePlan: props.data.disabledPrivatePlan,
                disabledProfilesQuantity: props.data.disabledProfilesQuantity,
                disabledPlanAvailability: props.data.disabledPlanAvailability,
                disabledPlanDescriptions: props.data.disabledPlanDescriptions,
                disabledRegionCountryIsos: props.data.disabledRegionCountryIsos,
                isEdit: props.data.isEdit ? props.data.isEdit : false,
                isReadOnly: props.data.isReadOnly ? props.data.isReadOnly : false
            });
        }
    }


    componentDidMount() {
        this.searchLanguages();
    }

    searchLanguages() {
        // This is promise
        let apiCall = ApiCalls.getLanguages();

        // After the api call, fill the data
        apiCall.then((data)=> {

            let options = [];
            let dataReturned = data.Languages;

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {
                this.state.languages.push({
                    name: dataReturned[i].Desc,
                    key: dataReturned[i].Code,
                    label: dataReturned[i].Code
                });
            }

            return options;
        });
    }

    /**
     * Render to add the descriptions
     * @returns {XML}
     */
    renderDescriptions() {
        return (
            <Row>
                {
                    this.state.languages.map(item => (
                        <Col sm={{size: 3}} key={item.key}>
                            <Button block color="info" value={item.key}
                                    disabled={this.state.disabledPlanDescriptions}
                                    onClick={this.openPlanDescriptionModal}>
                                {item.name}</Button>
                        </Col>
                    ))
                }
            </Row>
        );
    }

    /**
     * To open the lang description modal
     * @param e
     */
    openPlanDescriptionModal(e) {
        this.setState({
            planDescriptionCurrentLangCode: e.target.value,
            planDescriptionCurrentTitle: this.searchTitleTextByLangCode(e.target.value, this.state.planDescriptionDetails),
            planDescriptionCurrentDescription: this.searchDescriptionTextByLangCode(e.target.value, this.state.planDescriptionDetails),
            planDescriptionCurrentLangName: this.state.languages.find((item) => item.key === e.target.value).name,
            planDescriptionShowModal: true
        });
    }

    /**
     * Search the description by the lang code
     * @param langCode
     * @param objectArray
     * @returns {*}
     */
    searchDescriptionTextByLangCode(langCode, objectArray) {
        for (let i = 0; i < objectArray.length; i++) {
            if (objectArray[i].langCode === langCode)
                return objectArray[i].description;
        }
        return '';
    }

    /**
     * Search the title text by the lang code
     * @param langCode
     * @param objectArray
     * @returns {*}
     */
    searchTitleTextByLangCode(langCode, objectArray) {
        for (let i = 0; i < objectArray.length; i++) {
            if (objectArray[i].langCode === langCode)
                return objectArray[i].title;
        }
        return '';
    }

    /**
     * Updates the title text
     * @param langCode The lang code
     * @param titleText The title text
     * @param description the description
     */
    updateDescriptionText(langCode, titleText, description, callback) {
        let found = false;
        for (let i = 0; i < this.state.planDescriptionDetails.length; i++) {
            if (this.state.planDescriptionDetails[i].langCode === langCode) {
                this.state.planDescriptionDetails[i].title = titleText;
                this.state.planDescriptionDetails[i].description = description;
                this.setState({
                    planDescriptionCurrentTitle: this.state.planDescriptionDetails[i].title,
                    planDescriptionCurrentDescription: this.state.planDescriptionDetails[i].description
                });
                found = true;
            }
        }
        if (!found) {
            // Add the new description
            let objectDescription = {
                langCode: langCode,
                title: titleText,
                description: description
            };
            this.setState({
                planDescriptionCurrentTitle: titleText,
                planDescriptionCurrentDescription: description
            });
            this.state.planDescriptionDetails.push(objectDescription);
        }
        callback();
    }

    /**
     * Removes a value from array
     * @param array
     * @param xToRemove
     * @returns {*}
     */
    removeFromArray(array, xToRemove) {
        for (let i = array.length - 1; i >= 0; i--) {
            if (array[i] === xToRemove) {
                array.splice(i, 1);
            }
        }
        return array;
    }

    /**
     * Add a value to an array
     * @param array
     * @param xToAdd
     * @returns {*}
     */
    insertInArrayIfNotExists(array, xToAdd) {
        if (array.includes(xToAdd))
            return array;
        else {
            array.push(xToAdd);
            return array;
        }
    }


    /**
     * Submits the plan to the server
     */
    submitPlan() {
        if (this.state.planSubmitEnabled) {
            this.setState({
                loading: true
            }, ()=> {

                let apiCall;

                if (!this.state.isEdit)
                    apiCall = ApiCalls.insertPlan(this.prepareJsonSubmition());
                else
                    apiCall = ApiCalls.updatePlan(this.prepareJsonSubmition());

                // After the api call, fill the data
                apiCall.then((data)=> {
                    let messageToShow = '';
                    for (let i = 0; i < data.Messages.length; i++) {
                        messageToShow += data.Messages[i] + '<br/>';
                    }

                    let propsModal = {
                        bodyText: messageToShow,
                        visible: true
                    };

                    if (data.TransactionValid) {

                        if (this.state.isEdit) {
                            this.setState({
                                loading: false,
                                showModal: true,
                                propsModal: propsModal
                            });
                        }
                        else {
                            this.setState({
                                planId: data.Plans[0].Id,
                                propsModal: propsModal,
                                showModal: true,
                                loading: false,
                                disabledGenerics: true,
                                disabledPlanName: true,
                                disabledPlanForSchools: true,
                                disabledPrivatePlan: true,
                                disabledProfilesQuantity: true,
                                disabledPlanAvailability: true,
                                disabledPlanDescriptions: true,
                                disabledRegionCountryIsos: true,
                                planSubmitEnabled: false
                            }, ()=> {
                                // Update parent and send the plan Id
                                this.props.updateParent(this.state);
                                return this.state;
                            });
                        }
                    }
                    else
                        this.setState({
                            propsModal: propsModal,
                            showModal: true,
                            loading: false
                        });
                });
            });
        }
    }

    /**
     * Prepares the JSON submition
     */
    prepareJsonSubmition() {
        let PlanCreationModel = {
            ProductId: this.state.productId,
            Name: this.state.planName,
            Interval: this.state.interval,
            Currency: this.state.currencyIsoCode,
            Amount: this.state.price,
            IsForSchool: this.state.isForSchoolChecked ? "1" : "0",
            IsPrivate: this.state.isPrivate ? "1" : "0",
            ProfilesQuantity: this.state.studentQuantity,
            Available: this.state.isAvailableChecked ? "1" : "0",
            PlanTaxesIds: this.state.taxesSelected,
            TrialDays: this.state.tryPeriod,
            PlanDescriptionsByLang: [],
            PlanAvailableIsos: [],
            Id: this.state.planId
        };

        // Prepare the PlanDescriptionByLang
        for (let i = 0; i < this.state.planDescriptionDetails.length; i++) {
            PlanCreationModel.PlanDescriptionsByLang.push({
                LangCode: this.state.planDescriptionDetails[i].langCode,
                Name: this.state.planDescriptionDetails[i].title,
                Description: this.state.planDescriptionDetails[i].description
            });
        }

        // Prepare the plan available isos
        // Add the regions
        for (let i = 0; i < this.state.checkedRegionsValues.length; i++) {
            let regionString = this.state.checkedRegionsValues[i];
            var index = regionString.indexOf("|");  // Gets the first index where a space occours
            PlanCreationModel.PlanAvailableIsos.push({
                StateIso: regionString.substr(0, index),
                CountryIso: regionString.substr(index + 1)
            });
        }
        // Prepare the countries
        for (let i = 0; i < this.state.checkedValues.length; i++) {
            PlanCreationModel.PlanAvailableIsos.push({
                CountryIso: this.state.checkedValues[i]
            });
        }

        return PlanCreationModel;
    }

    /**
     * Validates if the
     * @param languages
     * @param planDescriptions
     */
    validateDescriptions(languages, planDescriptions) {
        let valid = true;
        this.setState({validDescriptions: true});
        if (planDescriptions.length < languages.length) {
            this.setState({validDescriptions: false});
            valid = false;
        }

        for (let i = 0; i < planDescriptions.length; i++) {
            if (typeof planDescriptions[i].description === 'undefined'
                || planDescriptions[i].description === null
                || planDescriptions[i].description.trim().length === 0
                || planDescriptions[i].description === "<p>&nbsp;</p>"
                || typeof planDescriptions[i].title === 'undefined'
                || planDescriptions[i].title === null
                || planDescriptions[i].title.trim().length === 0
                || planDescriptions[i].title === "<p>&nbsp;</p>"
            ) {
                this.setState({validDescriptions: false});
                valid = false;
                break;
            }
        }

        return valid;
    }

    /**
     * Evaluates if the plan is ready for submission
     */
    checkIfSubmitPlanButtonReady() {

        // Validtes the ones that are required
        if (this.state.validDescriptions
            && this.state.currencyIsoCode !== null
            && this.state.currencyIsoCode !== ''
            && this.state.currencyIsoCode !== '0'
            && this.state.productId !== null
            && this.state.planName !== null
            && this.state.planName.trim() !== ''
            && this.state.validPrice
            && this.state.tryPeriod !== null
            && this.state.validStudentQuantity
            && this.state.validDescriptions
            && (this.state.checkedValues.length > 0 || this.state.checkedRegionsValues.length > 0)
        ) {
            this.setState({planSubmitEnabled: true});
        }
        else
            this.setState({planSubmitEnabled: false});
    }

    /**
     * Handles the change for the html editors
     * @param event
     */
    handleChangeDescriptionEditor(data) {
        this.updateDescriptionText(data.languageCode, data.title, data.description, ()=> {
            this.validateDescriptions(this.state.languages, this.state.planDescriptionDetails);
        });
    }

    /**
     * Handles the checked taxes
     * @param event
     */
    handleCheckedTaxes(event) {
        this.setState({
            taxesSelected: event
        }, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    handleOnClickSearchPlan() {
        this.setState({
            modalPlanVisible: true
        });
    }

    /**
     * Handles the plan availability checkbox when is checked
     */
    handlePlanAvailability() {
        this.setState({isAvailableChecked: !this.state.isAvailableChecked}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles the student quantity input is changed
     * @param event
     */
    handleStudentQuantity(event) {

        if (event.target.value === null || event.target.value === '') {
            this.setState({
                validStudentQuantity: false,
                studentQuantity: ''
            }, ()=> {
                this.checkIfSubmitPlanButtonReady();
            });
        }
        else {
            if (this.isNormalInteger(event.target.value)) {
                this.setState({
                    validStudentQuantity: true,
                    studentQuantity: event.target.value
                }, ()=> {
                    this.checkIfSubmitPlanButtonReady();
                });
            }
        }
    }

    /**
     * Handles when the private checkbox is checked
     */
    handleIsPrivate(e) {
        this.setState({isPrivate: e.target.checked}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when is for school is checked
     */
    handleIsForSchool(e) {
        this.setState({isForSchoolChecked: e.target.checked}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when the country is changed
     * @param value
     */
    handleCurrencyChange(value) {
        this.setState({currencyIsoCode: value}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when interval is changed
     * @param value
     */
    handleInterval(value) {
        this.setState({interval: value}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when the product id is changed
     * @param value
     */
    handleProduct(value) {
        this.setState({productId: value}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when the plan name is changed
     * @param event
     */
    handleNameChange(event) {
        this.setState({planName: event.target.value}, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles when the price input is changed
     * @param event
     */
    handlePriceChange(event) {
        if (this.isNormalInteger(event.target.value)) {
            this.setState({price: event.target.value, validPrice: true}, ()=> {
                this.checkIfSubmitPlanButtonReady();
            });
        }
        else
            this.setState({price: null, validPrice: false}, ()=> {
                this.checkIfSubmitPlanButtonReady();
            });
    }

    /**
     * Handle the try period
     * @param event
     */
    handleTry(event) {
        if (this.isNormalInteger(event.target.value))
            this.setState({tryPeriod: event.target.value}, ()=> {
                this.checkIfSubmitPlanButtonReady();
            });
        else
            this.setState({tryPeriod: null}, ()=> {
                this.checkIfSubmitPlanButtonReady();
            });
    }

    /**
     * Evaluates if its a positive integer.
     * @param str
     * @returns {boolean}
     */
    isNormalInteger(str) {
        let n = Math.floor(Number(str));
        return n !== Infinity && String(n) === str && n >= 0;
    }

    /**
     * Handles the country and regions selection
     * @param event
     */
    handleCountryRegionsSelected(event) {
        this.setState({
            checkedValues: event.checkedValues,
            checkedRegionsValues: event.checkedRegionsValues
        }, ()=> {
            this.checkIfSubmitPlanButtonReady();
        });
    }

    /**
     * Handles the selected all countries
     */
    handleSelectAll(event) {
        this.setState({selectAll: event.target.checked});
    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal() {
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    toggleAlertModal() {
        this.setState({showModal: false});
    }

    handleSelectedPlan(e) {
        this.setState({
            modalPlanVisible: false,
            planId: e !== null ? e : null
        }, ()=> {
            if (this.state.planId !== null)
                this.searchPlan();
        })
    }

    searchPlan() {

        this.setState({
            loading: true
        },()=>{
            let apiCall = ApiCalls.getPlansAdvanced(this.state.planId,
                null, null, 1, 1, true);
            apiCall.then((data)=> {
                let Plan = data.Plans.Plans[0];

                // Prepare the descriptions
                let planDescriptionArray = [];
                for (let i = 0; i < Plan.PlanDescriptionByLang.length; i++) {
                    planDescriptionArray.push({
                        langCode: Plan.PlanDescriptionByLang[i].LangCode,
                        title: Plan.PlanDescriptionByLang[i].Name,
                        description: Plan.PlanDescriptionByLang[i].Description
                    })
                }

                // Prepare taxes
                let planTaxes = [];
                for (let i = 0; i < Plan.PlanTaxes.length; i++) {
                    planTaxes.push(Plan.PlanTaxes[i].TaxId);
                }

                // Prepare the countries
                let countriesSelected = [];
                let regionsSelected = [];

                for (let i = 0; i < Plan.PlanAvailableIsos.length; i++) {
                    if (Plan.PlanAvailableIsos[i].StateIso !== null) {
                        regionsSelected.push(Plan.PlanAvailableIsos[i].StateIso + "|" + Plan.PlanAvailableIsos[i].CountryIso);
                        continue; // Continue. Do not add the country alone.
                    }

                    if (Plan.PlanAvailableIsos[i].CountryIso !== null)
                        countriesSelected.push(Plan.PlanAvailableIsos[i].CountryIso);
                }

                this.setState({
                    currencyIsoCode: Plan.Currency,
                    interval: Plan.Interval,
                    productId: Plan.ProductId,
                    planName: Plan.Name,
                    price: Plan.Amount,
                    validPrice: true,
                    tryPeriod: Plan.TrialDays,
                    isForSchoolChecked: Plan.IsForSchool === "1",
                    isPrivate: Plan.IsPrivate === "1",
                    studentQuantity: Plan.ProfilesQuantity,
                    validStudentQuantity: true,
                    isAvailableChecked: Plan.Available === "1",
                    taxesSelected: planTaxes, // Prepare taxes object
                    planDescriptionDetails: planDescriptionArray,
                    validDescriptions: true,
                    planAvailableIsos: [], // Prepare object
                    checkedValues: countriesSelected, // Set checked countries
                    checkedRegionsValues: regionsSelected, // Set checked regions
                    planId: Plan.Id,
                    disabledGenerics: true,
                    disabledPlanName: true,
                    disabledPlanForSchools: true,
                    disabledPrivatePlan: true,
                    disabledProfilesQuantity: true,
                    disabledPlanAvailability: true,
                    disabledPlanDescriptions: true,
                    disabledRegionCountryIsos: true,
                    loading: false
                }, ()=> {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            });
        });
    }

    // Render the form group
    render() {
        return (
            <div>
                <Row>
                    <h2><b><Translate id="plan-creator.title"/></b></h2>
                </Row>
                <hr/>
                <Row>
                    <h4>
                        <small>
                            <Translate id="plan-creator.general-instructions"/>
                        </small>
                        {' '}
                        {
                            this.state.showAddExistingPlanButton ?
                                <Button color="warning" onClick={this.handleOnClickSearchPlan}>
                                    <Translate id="plan-creator.select-existing"/>
                                </Button> : null
                        }
                    </h4>
                </Row>

                <Row>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="interval">
                            <b><Translate id="product.product"/></b>
                        </Label>
                        <br/>
                        <SelectorPlanProduct disabled={this.state.disabledGenerics} value={this.state.productId}
                                             name="product" id="product" updateParent={this.handleProduct}/>
                        <br/>
                        {this.state.productId === null ?
                            <Alert color="danger">
                                <Translate id="product.product-select-error"/>
                            </Alert> : null
                        }
                    </Col>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="plan-name">
                            <b><Translate id="plan-creator.plan-name"/></b>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="plan-creator.plan-name-instructions"/>
                        </small>
                        <Input disabled={this.state.disabledPlanName} value={this.state.planName} type="text"
                               name="plan-name" id="plan-name" onChange={this.handleNameChange}/>
                        <br/>
                        {this.state.planName === '' ?
                            <Alert color="danger">
                                <Translate id="plan-creator.plan-name-error"/>
                            </Alert> : null
                        }
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="currency">
                            <b><Translate id="currency.currency"/></b>
                        </Label>
                        <SelectorCurrency disabled={this.state.disabledGenerics} name="currency" id="currency"
                                          value={this.state.currencyIsoCode}
                                          updateParent={this.handleCurrencyChange}/>
                        <br/>
                        {this.state.currencyIsoCode === null ?
                            <Alert color="danger">
                                <Translate id="currency.currency-error"/>
                            </Alert> : null
                        }
                    </Col>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="plan-name">
                            <b><Translate id="plan-creator.price-per-unit"/></b>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="plan-creator.price-instructions"/>
                        </small>
                        <Input value={this.state.price} disabled={this.state.disabledGenerics} type="number" min="0"
                               step="1" id="price-per-unit"
                               name="price-per-name" onChange={this.handlePriceChange}/>
                        <br/>
                        {
                            this.state.price === null || !this.state.validPrice ?
                                <Alert color="danger">
                                    <Translate id="plan-creator.price-per-unit-error"/>
                                </Alert> : null
                        }
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="interval">
                            <b><Translate id="billing-interval.billing-interval"/></b>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="billing-interval.billing-interval-instructions"/>
                        </small>
                        <SelectorBillingInterval value={this.state.interval} disabled={this.state.disabledGenerics}
                                                 name="interval" id="interval"
                                                 updateParent={this.handleInterval}/>
                        <br/>
                        {this.state.interval === null ?
                            <Alert color="danger">
                                <Translate id="billing-interval.billing-interval-error"/>
                            </Alert> : null
                        }
                    </Col>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="trial">
                            <b><Translate id="plan-creator.trial-period"/></b>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="plan-creator.trial-period-instructions"/>
                        </small>
                        <Input value={this.state.tryPeriod} disabled={this.state.disabledGenerics} type="number" min="0"
                               step="1" id="trial-period"
                               name="trial-period" onChange={this.handleTry}/>
                        <br/>
                        {this.state.tryPeriod === null ?
                            <Alert color="danger">
                                <Translate id="plan-creator.trial-period-error"/>
                            </Alert> : null
                        }
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="is-for-school">
                            <b><Translate id="plan-creator.is-for-school"/></b>
                        </Label>
                        <br/>
                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <small>
                                <Input disabled={this.state.disabledPlanForSchools} type="checkbox"
                                       name="is-for-school-checkbox" id="is-for-school"
                                       checked={this.state.isForSchoolChecked} onChange={this.handleIsForSchool}/>
                                <Translate id="plan-creator.is-for-school-instructions"/>
                            </small>
                        </Col>
                    </Col>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="is-for-school">
                            <b><Translate id="plan-creator.is-for-private"/></b>
                        </Label>
                        <br/>
                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <small>
                                <Input disabled={this.state.disabledPrivatePlan} type="checkbox"
                                       name="is-for-private-checkbox"
                                       id="is-for-private" checked={this.state.isPrivate}
                                       onChange={this.handleIsPrivate}/>
                                <Translate id="plan-creator.is-for-private-instructions"/>
                            </small>
                        </Col>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="profiles-quantity">
                            <b><Translate id="plan-creator.profiles-quantity"/></b>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="plan-creator.profiles-quantity-instructions"/>
                        </small>
                        <Input disabled={this.state.disabledProfilesQuantity} type="number"
                               value={this.state.studentQuantity} min="0" step="1" id="profile-quantity"
                               name="profile-quantity" onChange={this.handleStudentQuantity}/>
                        <br/>
                        {  !this.state.validStudentQuantity ?
                            <Alert color="danger">
                                <Translate id="plan-creator.profiles-quantity-error"/>
                            </Alert> : null
                        }
                    </Col>
                    <Col sm={{size: 12}} md={{size: 6}}>
                        <Label for="is-available">
                            <b><Translate id="plan-creator.is-available"/></b>
                        </Label>
                        <br/>
                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <small>
                                <Input disabled={this.state.disabledPlanAvailability} type="checkbox"
                                       name="is-available"
                                       id="is-available" checked={this.state.isAvailableChecked}
                                       onChange={this.handlePlanAvailability}/>
                                <Translate id="plan-creator.is-available-instructions"/>
                            </small>
                        </Col>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}}>
                        <Label for="taxes">
                            <b><Translate id="taxes.title"/></b>
                        </Label>
                        <br/>
                        <small><Translate id="taxes.instructions"/></small>
                        <CheckboxTaxes disabled={this.state.disabledGenerics} data={this.state}
                                       updateParent={this.handleCheckedTaxes}/>
                    </Col>
                </Row>

                <Row>
                    <h2><Translate id="plan-creator.description-by-language"/></h2>
                </Row>
                <Row>
                    <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        { this.state.languages !== null ?
                            this.renderDescriptions() : null
                        }
                    </Col>
                    <Col sm={{size: 12}}>
                        {
                            this.state.planDescriptionShowModal ?
                                <PlanDescriptionEditorSN disabled={this.state.disabledPlanDescriptions}
                                                         languageName={this.state.planDescriptionCurrentLangName}
                                                         title={this.state.planDescriptionCurrentTitle}
                                                         description={this.state.planDescriptionCurrentDescription}
                                                         languageCode={this.state.planDescriptionCurrentLangCode}
                                                         updateParent={this.handleChangeDescriptionEditor}
                                /> : null
                        }
                        <br/>
                        {   !this.state.validDescriptions ?
                            <Alert color="danger">
                                <Translate id="plan-creator.plan-details-error"/>
                            </Alert> : null
                        }
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col sm={{size: 12}}>
                        <h4><Translate id="iso-codes-applier.title"/></h4>
                        <p><Translate id="iso-codes-applier.instructions"/></p>
                    </Col>
                    <Col sm={{size: 10, offset: 1}}>
                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <Input type="checkbox" disabled={this.state.disabledRegionCountryIsos}
                                   onChange={this.handleSelectAll} checked={this.state.selectAll}/>
                            <Translate id="iso-codes-applier.select-all"/>
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{size: 10, offset: 1}}>
                        <CheckboxCountries disabled={this.state.disabledRegionCountryIsos} data={this.state}
                                           updateParent={this.handleCountryRegionsSelected}/>
                    </Col>
                    <Col sm={{size: 12}}>
                        <br/>
                        {   this.state.planAvailableIsos.length === 0 &&
                        (this.state.checkedRegionsValues.length === 0 && this.state.checkedValues.length === 0) ?
                            <Alert color="danger">
                                <Translate id="iso-codes-applier.error"/>
                            </Alert> : null
                        }
                    </Col>
                </Row>
                <hr/>
                {
                    !this.state.isReadOnly ?
                        <Row>
                            <Col sm={{size: 8}}><b><Translate id="plan-creator.validate-submission"/></b></Col>
                            <Col sm={{size: 4}}><Button onClick={this.submitPlan} color="success" block
                                                        disabled={!this.state.planSubmitEnabled}>
                                <Translate id="plan-creator.submit"/>
                            </Button>
                            </Col>
                        </Row> : null
                }
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ? this.renderGenericModal() : null }
                {this.state.modalPlanVisible ? <ModalPlanSelection visible={this.state.modalPlanVisible}
                                                                   updateParent={this.handleSelectedPlan}/> : null}
            </div>
        )
    };
}

export default FormGroupPlans;